<template>
    <div class="row" style="box-shadow: rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px; margin-bottom: 10px">
        <div class='form-group'>

            <div class="col-md-10 form-group">
                <label for="textarea-iframes">Targets</label>
                <textarea v-model="input.urls" :name=" type + '[' + index + '][urls]'" :key="index + 'url'"
                          class="form-control" style="height: 200px;"></textarea>
            </div>
            <div>
                <button @click="removeInput(index)" type="button" class="btn btn-danger">X</button>
            </div>
        </div>
        <div class="row col-md-12 from-group">

            <div class="col-md-2" v-if="type === 'mass_pixels'">
                <div class="custom-control custom-switch">
                    <input type="hidden" :name=" type + '[' + index + '][is_enabled_for_server_to_server]'"
                           v-model="input.is_enabled_for_server_to_server">

                    <input type="checkbox"
                           :name=" type + '[' + index + '][is_enabled_for_server_to_server]'"
                           v-model="input.is_enabled_for_server_to_server"
                           :checked="input.is_enabled_for_server_to_server ? 'checked' : undefined "
                           :true-value='1'
                           :false-value='0'
                           class="custom-control-input"
                    >
                    <label class="custom-control-label">Is Enabled For Server </label>
                </div>
            </div>
            <div v-show="!serverTrafficInputsShow">
                <div class="col-md-2">
                    <div class="custom-control custom-switch">

                        <input type="hidden" :name=" type + '[' + index + '][is_enabled_for_owned_websites]'"
                               v-model="input.is_enabled_for_owned_websites">

                        <input type="checkbox" :name="type + '[' + index + '][is_enabled_for_owned_websites]'"
                               v-model="input.is_enabled_for_owned_websites" :true-value='1'
                               :false-value='0' :checked="input.is_enabled_for_owned_websites ? 'checked' : undefined "
                               class="custom-control-input">
                        <label class="custom-control-label">Is Enabled For Owned Websites</label>
                    </div>
                </div>

                <div class="col-md-2" v-if="type === 'mass_pixels'">
                    <div class="custom-control custom-switch">
                        <input type="hidden" :name=" type + '[' + index + '][is_enabled_for_browser]'"
                               v-model="input.is_enabled_for_browser">

                        <input type="checkbox" :name=" type + '[' + index + '][is_enabled_for_browser]'"
                               v-model="input.is_enabled_for_browser"
                               :checked="input.is_enabled_for_browser ? 'checked' : undefined "
                               :true-value='1'
                               :false-value='0'
                               class="custom-control-input">

                        <label class="custom-control-label">Is Enabled For Browser</label>
                    </div>
                </div>

                <div class="col-md-2">
                    <div class="custom-control custom-switch">
                        <input type="hidden" :name=" type + '[' + index + '][is_enabled_for_traffic_code_redirect]'"
                               v-model="input.is_enabled_for_traffic_code_redirect">

                        <input type="checkbox" :name=" type + '[' + index + '][is_enabled_for_traffic_code_redirect]'"
                               v-model="input.is_enabled_for_traffic_code_redirect" true-value=1
                               false-value=0
                               :checked="input.is_enabled_for_traffic_code_redirect ? 'checked' : undefined"
                               class="custom-control-input">

                        <label class="custom-control-label">Is Enabled For Traffic Code Redirect</label>
                    </div>
                </div>

                <div class="col-md-2">
                    <div class="custom-control custom-switch">
                        <input type="hidden" :name=" type + '[' + index + '][is_enabled_for_traffic_code_static]'"
                               v-model="input.is_enabled_for_traffic_code_static">

                        <input type="checkbox" :name=" type + '[' + index + '][is_enabled_for_traffic_code_static]'"
                               :true-value='1'
                               :false-value='0' v-model="input.is_enabled_for_traffic_code_static"
                               :checked="input.is_enabled_for_traffic_code_static ? 'checked' : undefined"
                               class="custom-control-input">
                        <label class="custom-control-label">Is enabled for traffic code static</label>
                    </div>
                </div>
            </div>
            <div v-if="serverTrafficInputsShow && type === 'mass_pixels'" class="col-md-8">
                <label>Select Traffic Type</label>
                <input type="hidden" :name=" type + '[' + index + '][traffic_distribution_type]'"
                       v-model="selectedServerTrafficType">
                <select class="form-control" v-model="selectedServerTrafficType">
                    <option value="traffic_distribution_intervals">Intervals</option>
                    <option value="immediate">Immediate</option>
                </select>
            </div>
        </div>

        <div v-if="showDuplicatePercentageInput" class="col-md-12 form-group ">
            <label class="control-label">Change of duplicate</label>
            <input type="number" min="0" max="100" :name=" type + '[' + index + '][duplicate_hits_percentage]'" v-model="input.duplicate_hits_percentage"
                   class="form-control">
        </div>

        <div class="col-md-12 form-group ">
            <label class="control-label">Daily Simulated Hits</label>
            <input type="number" :name=" type + '[' + index + '][daily_simulated]'" v-model="input.daily_simulated"
                   class="form-control">
        </div>

        <div class="col-md-12 form-group">
            <label class="control-label">Period</label>
            <RangeDatePicker
                language="en"
                v-model="dates"
                v-show="showCalendar"
                @closePicker="closePicker"
            />
            <input
                @click="togglePicker"
                placeholder="Range picker"
                :value="rangeDates"
                :name="type + '[' + index + '][period]'"
                class="form-control"
                />
                <input
                    type="hidden"
                    :name="type + '[' + index + '][start_at]'"
                    :value="startDate"
                />
                <input
                    type="hidden"
                    :name="type + '[' + index + '][end_at]'"
                    :value="endDate"
                />
        </div>
        <div class="col-md-12 form-group ">
            <label class="control-label">Target Groups</label>
            <Select2
                :name=" type + '[' + index + '][target_group_ids][]'"
                v-model="selectedOptions"
                :options="targetGroupOptions"
                :settings="{multiple: true}"
            />
        </div>
    </div>
</template>
<script>

import Select2 from 'v-select2-component';
import RangeDatePicker from 'vue-easy-range-date-picker';

const DATE_FORMAT = 'DD/MM/YYYY HH:mm';

export default {
    name: "TargetInputGroup",
    props: ['input', 'index', 'type', 'targetGroupOptions'],
    components: {
        Select2,
        RangeDatePicker
    },
    data() {
        return {
            serverTrafficInputsShow: false,
            selectedServerTrafficType: null,
            selectedOptions: [],
            dates: {},
            showCalendar: false,
            showDuplicatePercentageInput: false,
        }
    },
    created() {
        if(this.type === 'mass_iframes') {
            if (!this.input.is_enabled_for_traffic_code_redirect) return;

            this.showDuplicatePercentageInput = true;

        }

        if (this.type === 'mass_pixels')  {
            if (!this.input.is_enabled_for_server_to_server) return;

            this.serverTrafficInputsShow = true;
            this.selectedServerTrafficType = 'traffic_distribution_intervals'
        }
    },

    computed: {
        startDate() {
            return this.parseTime(this.dates.start);
        },
        endDate() {
            return this.parseTime(this.dates.end);
        },
        rangeDates() {
            if (Object.keys(this.dates).length !== 2) {
                return '';
            }

            return `${this.parseTime(this.dates.start)}  -  ${this.parseTime(this.dates.end)}`;
        },
    },

    watch: {
        'input.is_enabled_for_traffic_code_redirect': function (newVal, oldVal) {
            if (newVal == 1 && this.type === 'mass_iframes') {
                this.showDuplicatePercentageInput = true;
                return;
            }

            this.showDuplicatePercentageInput  = false;

        },

        'input.is_enabled_for_server_to_server': function (newVal, oldVal) {
            if (newVal == 1) {
                this.typeServerToServerChecked();

                this.serverTrafficInputsShow = true;
                return;
            }

            this.selectedServerTrafficType = null;
            this.serverTrafficInputsShow = false;
        },

        selectedServerTrafficType(value) {
            if (value === null) {
                delete this.input['traffic_distribution_type'];
                return;
            }

            this.$set(this.input, 'traffic_distribution_type', this.selectedServerTrafficType);
        }

    },
    methods: {
        removeInput(index) {
            this.$emit('removeInputGroup', index)
        },

        typeServerToServerChecked() {
            this.selectedServerTrafficType = 'traffic_distribution_intervals';
            this.input.is_enabled_for_browser = 0;
            this.input.is_enabled_for_owned_websites = 0;
            this.input.is_enabled_for_traffic_code_static = 0;
            this.input.is_enabled_for_traffic_code_redirect = 0;
            this.input.traffic_distribution_type = 'traffic_distribution_intervals';
            this.serverTrafficInputsShow = true;
        },

        typeIsEnabledForIframeRedirectChecked() {
            this
        },

        closePicker() {
            this.showCalendar = false;
        },

        togglePicker() {
            this.showCalendar = !this.showCalendar;
        },

        parseTime(time) {
            return time && moment(time).format(DATE_FORMAT);
        },
    }
}
</script>

<style>
    .day {
        display: inline-grid !important;
    }
</style>



// WEBPACK FOOTER //
// resources/js/admin-panel/components/admin/mass-target-management/TargetInputGroup.vue